// extracted by mini-css-extract-plugin
export var closeButton = "_2d-0";